import LoadingButton from '@mui/lab/LoadingButton';
import cn from 'classnames';
import { FC } from 'react';

import styles from '../../../components/screens/Card/Card.module.sass';

interface IAddedToBasketButton {
  item: any;
  text: boolean;
  addToCart: (item: any) => void;
  isItemExistBasket: boolean;
}

const AddedToBasketButton: FC<IAddedToBasketButton> = ({
  item,
  text,
  addToCart,
  isItemExistBasket,
}) => {
  return (
    <>
      <LoadingButton
        variant="text"
        onClick={() => addToCart(item)}
        className={cn(styles.button, {
          [styles.inCart]: isItemExistBasket,
          [styles.remove]: isItemExistBasket,
          [styles.add]: !isItemExistBasket,
        })}
      >
        {text && (
          <>
            {isItemExistBasket ? <p>В корзине</p> : <p>Добавить в корзину</p>}
          </>
        )}
      </LoadingButton>
    </>
  );
};

export default AddedToBasketButton;
